import classNames from "classnames";
import { styled } from "~/common/mui";
import { C_PRIMARY, C_OUTLINE_VARIANT, C_WHITE } from "~/common/components/icon/Colors";
import CheckIcon from "@mui/icons-material/Check";

type Props = {
  checked?: boolean;
  className?: string;
  legacy?: boolean;
  alwaysVisible?: boolean;
} & Omit<JSX.IntrinsicElements["div"], "children">;

const StyledRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "checked" && prop !== "alwaysVisible",
})<{ checked?: boolean; alwaysVisible?: boolean }>(({ checked, alwaysVisible }) => ({
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  border: `1px solid ${C_OUTLINE_VARIANT}`,
  color: C_WHITE,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  pointerEvents: "none",
  visibility: alwaysVisible ? "visible" : "hidden",

  ...(checked && {
    borderColor: C_PRIMARY,
    backgroundColor: C_PRIMARY,
  }),
}));

export const CheckedCircle = ({ checked, className, legacy = true, alwaysVisible, ...rest }: Props) => {
  return (
    <StyledRoot
      checked={checked}
      alwaysVisible={alwaysVisible}
      className={classNames(className, legacy && "scha__lc__card__checkmark")}
      {...rest}
    >
      {checked && <CheckIcon sx={{ fontSize: "16px" }} />}
    </StyledRoot>
  );
};
